import { ModalLittle } from '../../../../../../../../baseComponents/Modal'
import { ModalOpenedSetTy } from '../../../../../../../../baseComponents/Modal/types';
import { RowData } from '../../../../../../../../baseComponents/TwinTable/types';
import TwinTrans from '../../../../../../../../baseComponents/TwinTrans'
import { TextField } from '../../../../../../../../forms/TextField';
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'

interface ModalWarehouseProductOrderProps {
    setOpened: ModalOpenedSetTy;
    allRowData?: RowData
}

const ModalWarehouseProductOrder: React.FC<ModalWarehouseProductOrderProps> = ({ setOpened, allRowData }) => {
    const { t } = useTwinTranslation()
    const renderThis: JSX.Element[] = []
    if (!allRowData) {
        return null
    }
    const productType = allRowData?.productType
    const serialLabel = productType === 3 ? t('serialNumber', 'Número de serie') : t('lotNumber', 'Número de lote')
    for (const element of allRowData.warehouseExtraData) {
        renderThis.push(
            <div className='my-10 w-full flex gap-40'>
                <TextField label={t('quantity', 'Cantidad')} value={element.quantity} />
                <TextField label={t('warehouse', 'Almacén')} value={allRowData.warehouses[element.WarehouseId].name} />
                {element.serialCode ? <TextField label={serialLabel} value={element.serialCode} />: null}
            </div>
        )
    }
    return (
        <ModalLittle opened={true} setOpened={setOpened}>
            <h2><TwinTrans transKey='warehouses'>Almacenes</TwinTrans></h2>
            <div className='flex flex-auto flex-col items-start overflow-y-auto my-15 h-5/6'>
                {renderThis}
            </div>
        </ModalLittle>
    )
}

export default ModalWarehouseProductOrder